import { useMemo } from 'react';
import stripeApi from '../api/stripeApi';

const useCreditPrice = () => {
  const { data, isError, isLoading } = stripeApi.useGetOneTimeProductsQuery();

  const price = useMemo(() => {
    if (isLoading || isError || !data) {
      return null;
    }

    const productPrice = data.find(
      ({ id }) => id === process.env.REACT_APP_CREDITS_TOP_UP_PRODUCT_ID
    )?.prices[0];

    if (!productPrice) {
      return null;
    }

    return productPrice;
  }, [data, isError, isLoading]);

  return price;
};

export default useCreditPrice;
